"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
//helpers


var dateRangesSample1 = [{
  ctaText: 'Yesterday',
  range: 'YESTERDAY',
  indicator: 'Yesterday'
}, {
  ctaText: 'Anytime',
  range: null,
  indicator: 'Anytime'
}, {
  ctaText: 'Today',
  range: 'TODAY',
  indicator: 'Today'
}, {
  ctaText: 'Last 10 Days',
  range: 10
}, {
  ctaText: 'Last 7 Days',
  range: 7
}, {
  ctaText: 'Last 10 Days',
  range: 10
}];
var dateRangesSample2 = [{
  ctaText: 'Last 30 Days',
  range: 30
}, {
  ctaText: 'Last 100 Days',
  range: 100
}];
/* ++++++++++ --------------- DATERANGEPICKERDROPDOWN : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'DateRangePickerDropDown',
  group: _definitionhelpers.groupNames.dropdowns,
  props: {
    handleApply: {
      type: 'function',
      default: function _default() {
        return console.log('Apply');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    updateRange: {
      type: 'function',
      default: function _default() {
        return console.log('Range updated');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    range: {
      // Object with strings
      type: 'object',
      default: {
        from: '2020-09-28',
        to: '2020-10-01'
      }
    },
    disabledDates: {
      type: 'object',
      default: [{
        after: new Date()
      }]
    },
    hideButtons: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    hideDateRangeHelpers: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    alignedRight: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    customDateRanges: {
      type: 'array',
      default: dateRangesSample1,
      options: []
    },
    customRangeClick: {
      type: 'function',
      default: function _default(range) {
        return console.log(range, 'This function is different from updateRange because you will have to collect the range then apply it');
      }
    },
    use4PMLogic: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    indicatorTitle: {
      type: 'string',
      default: 'Date modified'
    }
  }
};
exports.default = _default2;